// src/components/ContactInfoGrid.jsx

import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaPeopleArrows } from "react-icons/fa";
import ContactInfoCard from "../kits/ContactKit/ContactInfoCard";
import BookingModal from "./BookingModal";
import { useState } from "react";



const ContactInfoGrid = ({ onShowMapClick }) => {
  const [showBooking, setShowBooking] = useState(false);
  return (
    <div className="
    max-w-3xl 
    mx-auto
    grid 
    grid-cols-1 
    md:grid-cols-4 
    gap-4
    mt-10
    font-mono
    text-xs

    md:text-sm
    md:gap-6
    lg:gap-8
    


 

    ">
      <ContactInfoCard
        icon={FaPhoneAlt}
        title="per Handy"
        actionLabel="Jetzt anrufen"
        onClick={() => (window.location.href = "tel:015153231791")}
        color="text-gray-700"
        className="font-mono text-xs"
        
      >
        <span className="text-xs">+49 1515 3231791</span>
      </ContactInfoCard>

          <ContactInfoCard
        icon={FaPeopleArrows}
        title=""
        actionLabel="Tag aussuchen"
        onClick={() => setShowBooking(true)}   
        color="text-gray-700"
        font="font-mono text-xs"
      >
        <span className="text-xs">per Teams</span>
      </ContactInfoCard>


      <ContactInfoCard
        icon={FaEnvelope}
        title="per E-Mail"
        actionLabel="E-Mail schreiben"
        onClick={() => (window.location.href = "mailto:saghallo@denisbitter.de")}
        color="text-gray-700"
      >
        <span className="text-xs">saghallo</span>
        
      </ContactInfoCard>



      <ContactInfoCard
        icon={FaMapMarkerAlt}
        title="Standort"
        actionLabel="Map anzeigen"
        onClick={onShowMapClick}
        color="text-gray-700"
        font="font-mono text-xs"
      >
        <span className="text-xs">HH</span>
        
      </ContactInfoCard>

{/* Modal hier einfügen */}
      {showBooking && (
        <BookingModal onClose={() => setShowBooking(false)} />
      )}
    

    </div>
  );
};

export default ContactInfoGrid;
